import axios from 'axios';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarActividad = ({ refresh }) => {
  const [actividades, setActividades] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get(`/api/actividad/listbyid/${id}`);

      if (data && Array.isArray(data)) {
        const actividadesFormateadas = data.map((actividad) => {
          // Formato dd/mm/yyyy
          const fechaISO = new Date(actividad.fecha).toISOString().slice(0, 10); // '2025-06-24'
          const [anio, mes, dia] = fechaISO.split('-');
          const fechaFormateada = `${dia}/${mes}/${anio}`;

          return {
            ...actividad,
            fecha: fechaFormateada,
            funciones: (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-primary"
                  style={{ width: "30px", height: "30px", padding: "0" }}
                  onClick={() => navigate(`/asistencia/actividad/${actividad._id}`)}
                >
                  <i className="fa-solid fa-list-check"></i>
                </button>

                <button
                  className="btn btn-danger"
                  style={{ width: "30px", height: "30px", padding: "0" }}
                  onClick={() => deleteActividad(actividad._id)}
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            ),
          };
        });

        setActividades(actividadesFormateadas.reverse());
      } else {
        throw new Error("Datos de actividades no válidos.");
      }
    } catch (error) {
      console.error("Error al cargar las actividades:", error.message);
      Swal.fire("Error", "No se pudo cargar la lista de actividades.", "error");
    }
    // eslint-disable-next-line 
  }, [id]);

  useEffect(() => {
    getData();
  }, [getData, refresh]);

  const deleteActividad = useCallback(
    async (id) => {
      try {
        const result = await Swal.fire({
          title: '¿Está seguro?',
          text: '¡No podrá revertir este proceso!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, eliminar!',
        });

        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/actividad/delete/${id}`);
          await getData();

          await Swal.fire({
            icon: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } catch (error) {
        console.error('Error al eliminar la Actividad:', error.message);
        Swal.fire('Error', 'No se pudo eliminar la actividad.', 'error');
      }
    },
    [getData]
  );

  const columns = useMemo(() => [
    { Header: 'Nombre', accessor: 'nombreActividad' },
    { Header: 'Descripción', accessor: 'descripcion' },
    { Header: 'Fecha', accessor: 'fecha' },
    { accessor: 'funciones' },
  ], []);

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Lista de Actividades</h1>
      {Array.isArray(actividades) && actividades.length > 0 ? (
        <DataTable columns={columns} data={actividades} />
      ) : (
        <p>Cargando actividades...</p>
      )}
    </div>
  );
};

export default ListarActividad;
